import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { resendVerificationEmail } from "../../../Api/Backend/Auth";

const Step3_Complete = ({ email, password }) => {
  const navigate = useNavigate();

  const [isSending, setIsSending] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleResendEmail = async () => {
    if (!email || !password) {
      setErrorMessage("예상치 못한 오류입니다. 이메일을 다시 보내기에는 정보가 충분하지 않습니다.");
      return;
    }
    
    setIsSending(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    await resendVerificationEmail({
      email: email,
      password: password,
      onSuccess: () => {
        setSuccessMessage("이메일이 전송되었습니다");
        setIsSending(false);
      },
      onError: (error) => {
        setErrorMessage(
          error?.message || "이메일을 다시 보내는 중에 오류가 발생했습니다."
        );
        setIsSending(false);
      }
    })
  };


  return (
    <div className="signup-step-content complete-step">
      <h2>
        회원가입이 <strong>거의 완료</strong> 되었습니다.
      </h2>
      <p>
        가입하신 이메일로 <strong>인증 메일</strong>을 발송했습니다.
        <br />
        이메일을 확인하시고 인증을 완료해주세요.
      </p>
      <div className="form-actions">
        <button
          className="cancel-button"
          onClick={handleResendEmail}
          disabled={isSending}
        >
          이메일 다시 보내기
        </button>

        <button
          className="submit-button"
          onClick={() => navigate("/login")}
          disabled={isSending}
        >
          로그인
        </button>
      </div>

      {errorMessage &&
        <div className="error-message">{errorMessage}</div>
      }

{successMessage &&
        <div className="success-message">{successMessage}</div>
      }
    </div>
  );
};

export default Step3_Complete;
